import { createBrowserHistory } from 'history'
import qs from 'qs'

let _history = createBrowserHistory()

function addLocationQuery (history) {
  if (!history.location.search) return
  history.location = Object.assign(history.location, { query: qs.parse(history.location.search.substring(1)) })
}

addLocationQuery(_history)

_history.listen(() => {
  addLocationQuery(_history)
})

_history.mergeQueryString = obj => {
  const search = qs.parse(_history.location.search, {
    ignoreQueryPrefix: true
  })
  const nextSearch = { ...search, ...obj }
  _history.push({ search: qs.stringify(nextSearch) })
}

export default _history



// WEBPACK FOOTER //
// ./client/src/util/history.js